import React, { useState } from 'react';
import { Search } from 'lucide-react';
import UserList from './UserList';
import SearchInput from './SearchInput';

const ChatSidebar = ({ onSelectUser, selectedUser }) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="w-80 border-r border-gray-200 flex flex-col">
      <div className="p-4 border-b border-gray-200">
        <SearchInput
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder="Search employees..."
        />
      </div>
      <div className="flex-1 overflow-y-auto">
        <UserList
          searchQuery={searchQuery}
          onSelectUser={onSelectUser}
          selectedUser={selectedUser}
        />
      </div>
    </div>
  );
};

export default ChatSidebar;
